export const CARD = 'card';
export const SEPA = 'sepa';
